// Regular expression for splitting by commas and new lines
export const COMMA_NEWLINE_SPLITTER = /\s*,\s*|\n(?!\s*$)/g

